import { Text, VStack, Box } from '@chakra-ui/react'
import { useSpring } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import { AnimatedStack, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

export type ParagraphProps = {
  setCarouselIndex?: (index: number) => void
}

export interface SummaryProps {
  index?: number
  title: React.ReactNode
  Paragraph: React.FC<ParagraphProps>
  image: React.ReactNode
  id?: string
}

function Summary({
  index,
  title,
  Paragraph,
  image,
  id,
}: SummaryProps): React.ReactElement {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  })

  const spring = useSpring({
    to: {
      transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
      opacity: inView ? 1 : 0,
    },
    config: DEFAULT_SPRING_CONFIG,
  })

  return (
    <Box as="article" ref={ref} id={id}>
      <AnimatedStack
        spacing={{
          base: 2,
          sm: 6,
          md: 8,
        }}
        style={spring}
        direction={{
          base: 'column',
          sm: 'row',
        }}
        sx={{
          alignItems: {
            base: 'center',
            sm: 'flex-start',
          },
        }}
      >
        <Box
          sx={{
            flex: '0 0 fit-content',
            minH: {
              base: 14,
              sm: 10,
            },
            minW: {
              base: 14,
              sm: 10,
            },
          }}
        >
          {image}
        </Box>
        <VStack
          spacing="1"
          sx={{
            alignItems: {
              base: 'center',
              sm: 'flex-start',
            },
            textAlign: {
              base: 'center',
              sm: 'left',
            },
          }}
        >
          <Text as="h2" sx={{ fontWeight: 'medium', fontSize: 'lg' }}>
            {index} {title}
          </Text>
          <Paragraph />
        </VStack>
      </AnimatedStack>
    </Box>
  )
}

export default Summary
